<div class="wrapper wrapper-content" *ngIf="isLoaded()">
  <div class="container-fluid p-0">
    <div class="row p-0">
      <div class="col-12 p-0">
        <p-panel>
          <p-header>
            <span> <i class="fa fa-file" aria-hidden="true"></i> {{'General.filters'|translate}}</span>
          </p-header>
          <div class="col-12 p-0">
            <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
            </formPlyca>
          </div>
          <div class=" col-12 text-right"> <button class="btn btn-sm btn-secondary" (click)="this.clearFilter()"
              title="{{ 'General.reset.filters' | translate}}">
              <i class="fas fa-undo" aria-hidden="true"></i> <span> {{ 'General.reset.filters' | translate}}</span>
            </button>
            <button class="btn btn-sm btn-primary ml-2" (click)="this.loadData()"
              title="{{ 'General.search.text' | translate}}">
              <i class="fas fa-search" aria-hidden="true"></i> <span> {{ 'General.search.text' | translate}}</span>
            </button>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md p-0">
      <div class="col-12 p-0">
        <p-panel>
          <p-header>
            <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing'
              | translate }} {{elements ? elements.length : '0'}} {{'ControlPanel.inboxs.title'|translate}} </span>
          </p-header>
          <div class="alert alert-info col-12" role="alert" *ngIf="!elements || elements.length===0">
            <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
              'General.noData' | translate }}</span>
          </div>
          <p-table *ngIf="elements && elements.length>0" [responsive]="true" [value]="elements" sortField="identifier"
            sortOrder="1" [paginator]="false">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="identifier">{{'General.identifier'|translate}} <p-sortIcon field="identifier">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="name">{{'General.name'|translate}} <p-sortIcon field="name">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="description">{{'General.description'|translate}} <p-sortIcon field="description">
                  </p-sortIcon>
                </th>
                <th pSortableColumn="organizationalUnit.name">{{'General.organizationalUnitId'|translate}} <p-sortIcon
                    field="organizationalUnit.name">
                  </p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-element>
              <tr>
                <td><span class="p-column-title">{{'General.identifier'|translate}}</span>{{element.identifier}}</td>
                <td><span class="p-column-title">{{'General.name'|translate}}</span>{{element.name?element.name:'--'}}
                </td>
                <td><span
                    class="p-column-title">{{'General.description'|translate}}</span>{{element.description?element.description:'--'}}
                </td>
                <td><span
                    class="p-column-title">{{'General.organizationalUnitId'|translate}}</span>{{element.organizationalUnit&&element.organizationalUnit.name?element.organizationalUnit.name:'--'}}
                </td>
                <td class="text-right action-column-2">
                  <div class="float-right btn-group d-flex justify-content-end text-right">
                    <button class="btn btn-sm btn-secondary t-action-button" (click)="this.inboxTasks(element)"
                      title="{{ 'Audit.task' | translate}}">
                      <i class="fas fa-tasks" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-secondary t-action-button"
                      (click)="this.openInbox(element.identifier, true)" title="{{ 'General.view' | translate}}">
                      <i class="fas fa-eye" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-sm btn-secondary t-action-button"
                      (click)="this.openInbox(element.identifier)" title="{{ 'General.edit' | translate}}">
                      <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
    </div>
  </div>
</div>